var map = {
	"./replace-data-off.svg": "INWa",
	"./replace-data-on.svg": "EqZv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DUHR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/query ^\.\/replace\-data\-.*\.svg$
// module id = DUHR
// module chunks = 46